<script setup lang="ts">
defineProps<{ iconOnly?: boolean }>();

const tutorialUrl =
  "https://www.youtube.com/watch?v=CGKpDGLnYCw&list=PLkd-ATPCwe8WxYLlh-Xv93y21C6RFkoKO&index=4&t=6s";
const user = useCurrentUser();
const dismissedByUser = useLocalStorage<Record<string, boolean>>(
  "companion-overview-dismissed",
  {}
);
const isDismissed = computed(
  () => !user.value?.uid || dismissedByUser.value[user.value.uid] === true
);
const dismiss = () => {
  if (user.value?.uid) dismissedByUser.value[user.value.uid] = true;
};
</script>

<template>
  <a
    v-if="iconOnly"
    :href="tutorialUrl"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Watch the Writing Companion overview"
    title="Watch the Writing Companion overview"
    class="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded text-primary-default transition-colors hover:bg-primary-default/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-default"
  >
    <Icon name="lucide:circle-play" size="14" class="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
  </a>
  <aside
    v-else-if="!isDismissed"
    aria-label="Writing Companion tutorial"
    class="mb-6 flex items-start gap-3 rounded-lg border border-primary-default/20 bg-primary-default/5 p-4"
  >
    <Icon name="lucide:circle-play" size="22" class="mt-0.5 shrink-0 text-primary-default" aria-hidden="true" />
    <div class="min-w-0 grow">
      <p class="font-semibold text-gray-900">IEW Writing Companion Overview</p>
      <p class="mt-1 text-sm text-gray-600">Learn how to get started with IEW Writing Companion.</p>
      <a
        :href="tutorialUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="mt-2 inline-flex items-center gap-1.5 text-sm font-medium text-primary-default underline underline-offset-2 hover:no-underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-default"
      >
        Watch tutorial
        <Icon name="lucide:external-link" size="14" aria-hidden="true" />
      </a>
    </div>
    <button
      type="button"
      aria-label="Dismiss Writing Companion tutorial"
      title="Dismiss tutorial"
      class="-mr-1 -mt-1 inline-flex h-8 w-8 shrink-0 items-center justify-center rounded text-gray-500 hover:bg-primary-default/10 hover:text-gray-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-default"
      @click="dismiss"
    >
      <Icon name="lucide:x" size="18" aria-hidden="true" />
    </button>
  </aside>
</template>
